import { render, staticRenderFns } from "./PinglunSetting.vue?vue&type=template&id=9615fdfc&scoped=true&"
import script from "./PinglunSetting.vue?vue&type=script&lang=js&"
export * from "./PinglunSetting.vue?vue&type=script&lang=js&"
import style0 from "./PinglunSetting.vue?vue&type=style&index=0&id=9615fdfc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9615fdfc",
  null
  
)

export default component.exports